import React, { createContext, useLayoutEffect, useState } from 'react';
import { CartItemSchema, ICartItem } from '../schemas/cart-item';

export const validateStoredItems = (stringifyCart: string) => {
    try {
        const storedItems: any[] = JSON.parse(stringifyCart);

        return storedItems.map((storedItem) => CartItemSchema.parse(storedItem));
    } catch (e) {
        return false;
    }
};

interface ICartContext {
    items: ICartItem[]
    totalCount: number,
    setItem: (
        type: 'delivery' |'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
        uid: string,
        count: number,
        portionIndex?: number
    ) => void
    getItemCount: (
        type: 'delivery' |'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
        uid: string,
        portionIndex?: number
    ) => number
    clearItems: () => void
}

export const CartContext = createContext<ICartContext>({
    items: [],
    totalCount: 0,
    setItem: () => {
        throw new Error('Not implimented');
    },
    getItemCount: () => {
        throw new Error('Not implimented');
    },
    clearItems: () => {
        throw new Error('Not implimented');
    },
});

type CartProviderProps = {
    children: React.ReactNode
}

export const CartProvider: React.FC<CartProviderProps> = ({
    children,
}) => {
    const [items, setItems] = useState<ICartItem[]>([]);
    const [totalCount, setTotalCount] = useState(0);

    const setItem = (
        type: 'delivery' |'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
        uid: string,
        count: number,
        portionIndex?: number,
    ) => {
        if (count < 0) {
            throw new Error('Parameter count less then or equals 0');
        }
        const existItemIndex = items.findIndex(({
            type: storedType,
            uid: storedUid,
            portionIndex: storedPortionIndex,
        }) => (
            type === storedType
            && storedUid === uid
            && portionIndex === storedPortionIndex
        ));

        const newItems = items;
        if (existItemIndex > -1) {
            newItems[existItemIndex] = {
                type,
                uid,
                portionIndex,
                count,
            };
        } else {
            newItems.push({
                type,
                uid,
                portionIndex,
                count,
            });
        }
        setItems(newItems);

        localStorage.setItem('CART_ITEMS', JSON.stringify(items));

        let newTotalcount = 0;

        items.forEach(({ count }) => {
            newTotalcount += count;
        });

        setTotalCount(newTotalcount);
    };

    const getItemCount = (
        type: 'delivery' |'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
        uid: string,
        portionIndex?: number,
    ) => {
        const s = (
            items.find(({
                type: storedType,
                uid: storedUid,
                portionIndex: storedPortionIndex,
            }) => (
                type === storedType
                && storedUid === uid
                && portionIndex === storedPortionIndex
            ))
        );

        return s?.count || 0;
    };

    const clearItems = () => {
        setItems([]);
        localStorage.setItem('CART_ITEMS', JSON.stringify([]));
    };

    // useEffect(() => {
    //     console.log(items);
    //     localStorage.setItem('CART_ITEMS', JSON.stringify(items));

    //     let newTotalcount = 0;

    //     items.forEach(({ count }) => {
    //         newTotalcount += count;
    //     });

    //     setTotalCount(newTotalcount);
    // }, [JSON.stringify(items)]);

    useLayoutEffect(() => {
        const stringifyCart = localStorage.getItem('CART_ITEMS');
        if (stringifyCart) {
            const parceResult = validateStoredItems(stringifyCart);
            if (parceResult) {
                setItems(parceResult);
                let newTotalcount = 0;

                parceResult.forEach(({ count }) => {
                    newTotalcount += count;
                });

                setTotalCount(newTotalcount);
            }
        }
    }, []);

    return (
        <CartContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                items,
                totalCount,
                setItem,
                getItemCount,
                clearItems,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};
